import { StyledSpinner } from './styles/Spinner.style'

export const Spinner = () => {
  return <StyledSpinner />
}
